import styled from "styled-components";
import { SIDE_BAR_WIDTH } from "../../constants";
import HeaderBannerPng from "./../../icons/headerBanner.png";

export const StyledFeedDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Banner = styled.div`
  height: 248px;
  width: calc(100vw - ${SIDE_BAR_WIDTH});
  min-width: 1160px;
  box-sizing: border-box;
  background: url(${HeaderBannerPng});
  color: #ffffff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 116px 68px 0px 68px;
  z-index: 3;
  position: fixed;
`;

export const ClientName = styled.div`
  font-size: 32px;
  font-family: HelveticaNeue-Bold;
  letter-spacing: -0.2px;
  margin-bottom: 2px;
  cursor: pointer;
`;

export const FeedName = styled.div`
  font-size: 16px;
  font-family: HelveticaNeue;
  letter-spacing: 1px;
  margin-bottom: 24px;
  letter-spacing: 0.89px;
`;

export const FeedType = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  letter-spacing: 0.75px;
  font-family: HelveticaNeue-Medium;

  svg {
    margin-right: 12px;
  }
`;

export const FeedDetailContent = styled.div`
  display: flex;
  padding: 300px 70px 40px;
  position: relative;
`;

export const Nav = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 70px;
  min-width: 95px;
  position: fixed;
`;

export const NavButton = styled.div`
  display: flex;
  align-items: center;
  border-left: 2px solid ${(props) => (props.isActive ? "#6f7bf2" : "#d4d3e6")};
  height: 40px;
  padding-left: 20px;
  color: #212530;
  font-family: HelveticaNeue;
  font-size: 12px;
  font-weight: ${(props) => (props.isActive ? "700" : "500")};
  letter-spacing: 0.39px;
  cursor: pointer;
`;

export const RightNav = styled.div`
  margin-left: 24px;
  padding-bottom: 32px;

  max-height: 36px;
  min-width: 176px;
`;

export const Action = styled.div`
  padding-left: 30px;
  display: flex;
  align-items: center;
  color: ${(props) => (props.isDisabled ? "#9b9ab7" : "#5d69e6")};
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.39px;
  line-height: 36px;
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};

  svg {
    margin-right: 20px;
  }
`;
